// extracted by mini-css-extract-plugin
export var width100 = "G_w d_w";
export var design3Pos = "G_wy d_0";